import type { PriceListUerRowBase } from 'gql/graphql';

import * as R from 'ramda';

export const getPriceListUerForConstraintRatioGroupedData = (items: PriceListUerRowBase[], endRow?: number) => {
    const headRow = R.head(items);

    return [
        ...(headRow && endRow === 50
            ? [
                  {
                      id: headRow.sectionId,
                      groupName: headRow.sectionName,
                      type: 'section',
                      sectionIsArtificial: headRow.sectionIsArtificial,
                      groupRowId: `groupRow_${headRow.sectionId}`,
                  },
              ]
            : []),
        ...items,
    ];
};
